<template>
    <div class="tw-flex tw-flex-col tw-items-center lg:tw-self-baseline tw-self-center">
        <storage-avatar
                :user="user"
                :size="8"
        />
        <div
                v-if="!isEmpty(companyLogo)"
                class="pro-company-logo 3xl:tw-h-[7.5rem] 3xl:tw-w-[7.5rem] xl:tw-w-[6.75rem] xl:tw-h-[6.75rem] tw-w-44 tw-h-[7.5rem] tw-mt-4">
            <img
                class="tw-w-full tw-h-full tw-object-contain"
                :src="companyLogo"
                alt="Company logo"
            />
        </div>
    </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import UserAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/UserAppResource";
import StorageAvatar from "../../../StorageImage/StorageAvatar.vue";

export default {
    name: 'ProfileAndCompany',
    components: {
        StorageAvatar
    },
    mixins: [],
    props: {
        companyLogo: {
            type: String,
            required: true,
        },
        user: {
            type: UserAppResource,
            required: true,
        }
    },
    data() {
        return {};
    },
    computed: {

    },
    methods: {
        isEmpty

    },

};
</script>
